import { LinearProgress, makeStyles, Typography } from '@material-ui/core';
import Delay from 'react-delay';

interface Properties {
  titre?: string;
  message?: string;
}

const useStyles = makeStyles((theme) => ({
  loadingContainer: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  }
}));

const LoadingMessageBox: React.FC<Properties> = ({ titre, message }) => {
  const styles = useStyles();
  return (
    <>
      <Delay wait={500}>
        <div className={styles.loadingContainer}>

          {titre && <Typography variant="h3">{titre}</Typography>}
          {message && <Typography variant="h4">{message}</Typography>}
          <LinearProgress />
        </div>
      </Delay>
    </>
  );
};

export default LoadingMessageBox;